export const Scopes = {
  Admins: {
    show: 'Admin-admin-show',
    store: 'Admin-admin-store',
    update: 'Admin-admin-update',
    delete: 'Admin-admin-delete',
  },
  Users: {
    show: 'Admin-user-show',
    store: 'Admin-user-store',
    update: 'Admin-user-update',
    delete: 'Admin-user-delete',
  },
  Fingerprint: {
    show: 'Admin-fingerprint-show',
    store: 'Admin-fingerprint-store',
    update: 'Admin-fingerprint-update',
    delete: 'Admin-fingerprint-delete',
  },
  Group: {
    show: 'Admin-group-show',
    store: 'Admin-group-store',
    update: 'Admin-group-update',
    delete: 'Admin-group-delete',
  },
  Registry: {
    show: 'Admin-registry-show',
    config: 'Admin-registry-config',
    store: 'Admin-registry-store',
    update: 'Admin-registry-update',
  },
  Kiosk: {
    show: 'Admin-kiosk-show',
    delete: 'Admin-kiosk-delete',
    store: 'Admin-kiosk-store',
    update: 'Admin-kiosk-update',
  },
  Torniquet: {
    show: 'Admin-torniquet-show',
    delete: 'Admin-torniquet-delete',
    store: 'Admin-torniquet-store',
    update: 'Admin-torniquet-update',
  },
  Location: {
    show: 'Admin-location-show',
    update: 'Admin-location-update',
    store: 'Admin-location-store',
  },
  Access: {
    show: 'Admin-access-show',
    delete: 'Admin-access-delete',
  },
  Payment: {
    show: 'Admin-payment-show',
    update: 'Admin-payment-update',
    delete: 'Admin-payment-delete',
  },
  Company: {
    show: 'Admin-company-show',
    update: 'Admin-company-update',
  },
  Recognition: {
    show: 'Admin-recognition-show',
    store: 'Admin-recognition-store',
    update: 'Admin-recognition-update',
    delete: 'Admin-recognition-delete',
  },
};

export const hasScope = (currentSubjectScopes, module, permission) => {
  if (!currentSubjectScopes || !module || !permission) return false;

  const scopeToValidate = Scopes?.[module]?.[permission];

  if (!scopeToValidate) {
    return false;
  }

  const isValid =
    currentSubjectScopes.includes('*') || currentSubjectScopes.includes(scopeToValidate);

  return isValid;
};

export const hasScopeForSubmodule = (currentSubjectScopes, module, submodule, permission) => {
  if (!currentSubjectScopes || !module || !submodule || !permission) return false;

  const scopeToValidate = Scopes?.[module]?.[submodule]?.[permission];

  if (!scopeToValidate) {
    return false;
  }

  const isValid =
    currentSubjectScopes.includes('*') || currentSubjectScopes.includes(scopeToValidate);

  return isValid;
};

export const getPermissionsForModule = (module) => {
  const modulePermissions = Scopes?.[module];

  if (!modulePermissions) {
    return [];
  }

  return Object.values(modulePermissions);
};

export const getPermissionsForModuleWithSubmodule = (module, submodule) => {
  const modulePermissions = Scopes?.[module]?.[submodule];

  if (!modulePermissions) {
    return [];
  }

  return Object.values(modulePermissions);
};
